"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getFieldName = void 0;
var translation_1 = require("@caddigital/sok-reducers/lib/utils/translation");
var localisationRootKey = 'management/reports/modal/fields/';
var getFieldName = function (fetchedFieldName) {
    return (0, translation_1.getLocalization)(localisationRootKey + fetchedFieldName);
};
exports.getFieldName = getFieldName;
